import Vue from 'vue';
import i18next from 'i18next';
import 'unorm';

import { LOCALES, LOCALE_SETTINGS } from '@/core/i18n/constants';

const languagesWithUppercaseDiacritics: string[] = [
    LOCALE_SETTINGS[LOCALES.English].culture,
    LOCALE_SETTINGS[LOCALES.Deutsch].culture,
    LOCALE_SETTINGS[LOCALES.Polish].culture,
    LOCALE_SETTINGS[LOCALES.Croatian].culture
];

export function removeDiacritics(
    value: string = '',
    exclude: string[] = languagesWithUppercaseDiacritics
) {
    return exclude.indexOf(i18next.language) === -1 && value.length > 1
        ? value.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        : value;
}

Vue.filter('uppercase', (value: string, exclude: string[]) => removeDiacritics(value, exclude).toUpperCase());

